export const breakpointUpMixin = (breakpointPx: number): string =>
  `min-width: ${breakpointPx / 16}em`;

export const breakpointDownMixin = (breakpointPx: number): string =>
  `max-width: ${(breakpointPx - 1) / 16}em`;
